/* eslint-disable */
import * as THREE from 'three'
import FBXLoader from 'three-fbx-loader';

class Bracelet {
  constructor(DOMContainer) {
    this.DOMContainer = DOMContainer;
    this.DOMRect = this.DOMContainer.getBoundingClientRect();
    this.THREE = THREE;
    this.time = 0;
    this.screen = {
      width: this.DOMRect.width,
      height: this.DOMRect.height,
      ratio: this.DOMRect.width / this.DOMRect.height,
      density: window.devicePixelRatio,
    };

    this.renderer = new this.THREE.WebGLRenderer({
      antialias: true,
      alpha: false,
      powerPreference: 'high-performance',
    });
    this.renderer.setClearColor(0x000000, 1);
    this.renderer.setSize(window.innerWidth / 2, window.innerHeight);

    this.scene = new this.THREE.Scene();

    this.camera = new this.THREE.OrthographicCamera(
      window.innerWidth / -4,
      window.innerWidth / 4,
      window.innerHeight / 2,
      window.innerHeight / -2,
      -500,
      500,
    );
    this.camera.position.z = 1;
    // const cameraHelper = new this.THREE.CameraHelper(this.camera);
    // this.scene.add(cameraHelper);

    this.DOMContainer.appendChild(this.renderer.domElement);
  }

  resize() {
    this.DOMRect = this.DOMContainer.getBoundingClientRect();
    this.screen.ratio = this.DOMRect.width / this.DOMRect.height;
    this.renderer.setSize(this.DOMRect.width, this.DOMRect.height);
    const scale = 40 * window.innerWidth / 1440;
    this.bracelet.scale.set(scale, scale, scale);

    this.camera.left = this.DOMRect.width / -2;
    this.camera.right = this.DOMRect.width / 2;
    this.camera.top = this.DOMRect.height / 2;
    this.camera.bottom = this.DOMRect.height / -2;
    this.camera.updateProjectionMatrix();
  }

  loadMesh(string) {
    const loader = new FBXLoader();
    const envMap = new this.THREE.TextureLoader().load('/static/bracelet/env.jpg');
    envMap.mapping = this.THREE.SphericalReflectionMapping;
    const material = new this.THREE.MeshPhysicalMaterial({
      // Color map
      map: new this.THREE.TextureLoader().load('/static/bracelet/color-1.jpg'),
      // Bump map
      bumpMap: new this.THREE.TextureLoader().load('/static/bracelet/bump-1.jpg'),
      bumpScale: 0.2,
      // Roughness map
      roughnessMap: new this.THREE.TextureLoader().load('/static/bracelet/roughness-1.jpg'),
      roughness: 1,
      //emissive map
      emissive: 0xffffff,
      emissiveMap: new this.THREE.TextureLoader().load('/static/bracelet/emissive.jpg'),
      emissiveIntensity: 0.8,
      // Refelctions and shiniess params
      envMap,
      envMapIntensity: 0.3,
      metalness: 0.0,
      reflectivity: 0,
    });
    material.needsUpdate = true;

    const promise = new Promise((resolve) => {
      loader.load(string, (object) => {
        this.bracelet = object.children[0];
        this.bracelet.material = material;
        const scale = 40 * window.innerWidth / 1440;
        this.bracelet.scale.set(scale, scale, scale);
        this.scene.add(this.bracelet);

        resolve();
      });
    });

    return promise;
  }

  setup() {
    const ambientLight = new this.THREE.AmbientLight(0x202020);
    const pointLight = new this.THREE.PointLight(0xffffff, 1, 1050);
    pointLight.position.x = -200;
    pointLight.position.y = 0;
    pointLight.position.z = 300;

    this.scene.add(ambientLight);
    this.scene.add(pointLight);
  }

  setupObj() {
    this.bracelet.rotation.y = this.THREE.Math.degToRad(-20);
    this.bracelet.rotation.x = this.THREE.Math.degToRad(-60);
  }

  render(time) {
    this.time += time;
    this.renderer.render(this.scene, this.camera);
  }

  get rotationY() {
    return this.bracelet.rotation.y;
  }

  set rotationY(deg) {
    this.bracelet.rotation.y = this.THREE.Math.degToRad(deg);
  }

  get rotationX() {
    return this.bracelet.rotation.x;
  }

  set rotationX(deg) {
    this.bracelet.rotation.x = this.THREE.Math.degToRad(deg);
  }

  get translateY() {
    return this.bracelet.rotation.x;
  }

  set translateY(deg) {
    this.bracelet.rotation.x = this.THREE.Math.degToRad(deg);
  }

  get translateX() {
    return this.bracelet.rotation.x;
  }

  set translateX(deg) {
    this.bracelet.rotation.x = this.THREE.Math.degToRad(deg);
  }
}

export default Bracelet;



// WEBPACK FOOTER //
// ./src/scripts/Bracelet.js